var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accountSecurity" },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "title-mb": _vm.titleArray[0],
          "type-next": "click"
        },
        on: { navBarClick: _vm.navBarClick }
      }),
      _c("div", { staticClass: "formClass" }, [
        _vm.isShow && !_vm.columns.length
          ? _c("div", { staticClass: "account-security-title" }, [
              _c("p", [_vm._v("亲爱的玩家，您当前的雷霆账号没有关联游戏")])
            ])
          : _vm._e(),
        _vm.columns.length && _vm.active === 0
          ? _c(
              "div",
              { staticClass: "account-security-one" },
              [
                _vm._m(0),
                _c(
                  "ul",
                  { staticClass: "account-security-list" },
                  [
                    _vm._m(1),
                    _vm._l(_vm.columns, function(item, i) {
                      return _c(
                        "li",
                        {
                          key: i,
                          class: item.status === 0 ? "highlight__red" : ""
                        },
                        [
                          _c("p", [_vm._v(_vm._s(item.gameName))]),
                          _c("p", [
                            _vm._v(_vm._s(item.status === 1 ? "是" : "否"))
                          ])
                        ]
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "van-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "normal",
                      color: "#606DE2",
                      plain: "",
                      round: ""
                    },
                    on: {
                      click: function($event) {
                        _vm.active = 1
                      }
                    }
                  },
                  [_vm._v("设置")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm.columns.length && _vm.active === 1
          ? _c(
              "div",
              { staticClass: "account-security-two" },
              [
                _vm._m(2),
                _c(
                  "ul",
                  { staticClass: "account-security-list" },
                  [
                    _vm._m(3),
                    _vm._l(_vm.columnsModify, function(item, i) {
                      return _c(
                        "li",
                        {
                          key: i,
                          class:
                            item.status === 1 && item.safeResult.length
                              ? ""
                              : "highlight__red"
                        },
                        [
                          _c(
                            "van-checkbox-group",
                            {
                              model: {
                                value: item.safeResult,
                                callback: function($$v) {
                                  _vm.$set(item, "safeResult", $$v)
                                },
                                expression: "item.safeResult"
                              }
                            },
                            [
                              _c(
                                "van-checkbox",
                                {
                                  attrs: {
                                    name: item.game,
                                    shape: "square",
                                    "checked-color": "#606DE2"
                                  }
                                },
                                [_vm._v(_vm._s(item.gameName))]
                              )
                            ],
                            1
                          ),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                item.status === 1 && item.safeResult.length
                                  ? "是"
                                  : "否"
                              )
                            )
                          ])
                        ],
                        1
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "van-form",
                  { on: { submit: _vm.handleSubmit } },
                  [
                    _c("van-field", {
                      staticStyle: { "border-radius": "16px" },
                      attrs: {
                        label: "将发短信至绑定手机号：" + _vm.encryptedPhone,
                        maxlength: "6",
                        rules: _vm.rules.codeRules,
                        placeholder: "请输入验证码"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button",
                            fn: function() {
                              return [
                                !_vm.showTime
                                  ? _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          color: "#616edf",
                                          cursor: "pointer"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.getCode(
                                              "MODIFY_PWD_LOGIN_CODE_VERIFY"
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.timeMsg))]
                                    )
                                  : _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          color: "#878787",
                                          cursor: "pointer"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.codeTime) + " S")]
                                    )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        703253303
                      ),
                      model: {
                        value: _vm.securityGame.code,
                        callback: function($$v) {
                          _vm.$set(_vm.securityGame, "code", $$v)
                        },
                        expression: "securityGame.code"
                      }
                    }),
                    _c("p", { staticClass: "reg_p" }, [
                      _vm._v("*如果1分钟内没有收到验证码请重新获取")
                    ])
                  ],
                  1
                ),
                _vm._m(4),
                _c(
                  "div",
                  { staticClass: "account-security-btn" },
                  [
                    _c(
                      "van-button",
                      {
                        attrs: {
                          size: "normal",
                          color: "#606DE2",
                          plain: "",
                          round: ""
                        },
                        on: {
                          click: function($event) {
                            _vm.active = 0
                          }
                        }
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "van-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "normal",
                          color: "#606DE2",
                          round: ""
                        },
                        on: { click: _vm.handleSubmit }
                      },
                      [_vm._v("确认")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "account-security-title" }, [
      _c("p", [
        _vm._v(
          "为了保障您的账户安全，在新设备上首次使用账号密码登录时，推荐通过短信验证码进行额外的安全验证。以下是各游戏的具体设置情况："
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("p", [_vm._v("游戏名")]),
      _c("p", [_vm._v("是否开启短信验证")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "account-security-title" }, [
      _c("p", [_vm._v("请选择开启短信验证的游戏：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("p", [_vm._v("游戏名")]),
      _c("p", [_vm._v("是否开启短信验证")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "account-security-tips" }, [
      _c("h4", [_vm._v("温馨提示：")]),
      _c("p", [
        _vm._v(
          "每日可操作3次，当前为开启状态。功能关闭后您的的账号在新设备或者长久不登录的设备使用账密登录，将不再需要短信校验，存在账号被盗风险，为保障您的账号安全，请谨慎操作。"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }